// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonSecondary_button__3TXIo","gradientText":"ButtonSecondary_gradientText__3xJyR"};